import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
	width: 100%;
	height: 400px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;


export default function PopupContainer(props){
	return (
		<Container style={ props.style }>
			<Outlet/>
		</Container>
  	);
}
